import { IRouteType } from '../../types'
import bibibopAccountingSalesReport from './bibibopAccountingSalesReport'
import bibibopDelivery from './bibibopDelivery'
import bibibopExpenses from './bibibopExpenses'
import bibibopFlash from './bibibopFlash'
import bibibopGroupManagementConfig from './bibibopGroupManagement'
import bibibopHaccps from './bibibopHaccps'
import bibibopHome from './bibibopHome'
import bibibopIntraday from './bibibopIntraday'
import bibibopInventory from './bibibopInventory'
import bibibopKpis from './bibibopKips'
import bibibopLocationManagementConfig from './bibibopLocationManagement'
import bibibopOpsDashboard from './bibibopOpsDashboard'
import bibibopOriginalPages from './bibibopOriginalPages'
import bibibopPAndL from './bibibopPAndL'
import bibibopProduct from './bibibopProduct'
import bibibopRankings from './bibibopRankings'
import bibibopSystemwideOverview from './bibibopSystemwideOverview'

export const routes: IRouteType[] = [
  {
    title: 'Corporate',
    children: [
      {
        title: 'Expo AI',
        link: '/:brand/expo_ai',
        useOriginal: true,
      },
      {
        title: 'Systemwide Overview',
        link: '/:brand/systemwide_overview',
        default: true,
      },
      {
        title: 'Today',
        link: '/:brand/corporate-today',
      },
      {
        title: 'Flash',
        link: '/:brand/flash',
      },
      {
        title: 'KPIs',
        link: '/:brand/kpis',
      },
      {
        title: 'Rankings',
        link: '/:brand/rankings',
      },
      {
        title: 'Team',
        link: '/:brand/corporate_team',
        useOriginal: true,
      },
      {
        title: 'Loss Prevention',
        link: '/:brand/corporate_loss_prevention',
        useOriginal: true,
      },
      {
        title: 'Inventory',
        link: '/:brand/corporate_inventory',
      },
      {
        title: 'Guest',
        link: '/:brand/corporate_guest',
        useOriginal: true,
      },
      {
        title: 'Delivery',
        link: '/:brand/corporate_delivery',
      },
      {
        title: 'Rational',
        link: '/:brand/rational',
      },
      {
        title: 'Expenses',
        link: '/:brand/expenses',
      },
      {
        title: 'Ops Dashboard',
        link: '/:brand/ops-dashboard',
      },
      {
        title: 'Product',
        link: '/:brand/product',
      },
    ],
  },
  {
    title: 'Store',
    children: [
      {
        title: 'Home',
        link: '/:brand/scorecard',
      },
      {
        title: 'Today',
        link: '/:brand/today',
      },
      {
        title: 'Store Performance',
        link: '/:brand/store_detail',
        useOriginal: true,
      },
      {
        title: 'Team',
        link: '/:brand/team',
        useOriginal: true,
      },
      {
        title: 'Loss Prevention',
        link: '/:brand/loss_prevention',
        useOriginal: true,
      },
      {
        title: 'Inventory',
        link: '/:brand/inventory',
      },
      {
        title: 'Guest',
        link: '/:brand/guest',
        useOriginal: true,
      },
      {
        title: 'Delivery',
        link: '/:brand/delivery',
      },
      {
        title: 'P&L',
        children: [
          {
            title: 'Store Opportunities',
            link: '/:brand/p-and-l-store-opportunities',
          },
          {
            title: 'P&L Table',
            link: '/:brand/p-and-l',
          },
        ],
      },
    ],
  },
  {
    title: 'Finance',
    children: [
      {
        title: 'P&L',
        link: '/:brand/corporate-p-and-l',
      },
      {
        title: 'Executive Summary',
        link: '/:brand/executive-summary',
      },
      {
        title: 'Corporate Opportunities',
        link: '/:brand/corporate-opportunities',
      },
      {
        title: 'Store Opportunities',
        link: '/:brand/store-opportunities',
      },
      {
        title: 'Rankings',
        link: '/:brand/p-and-l-rankings',
      },
      {
        title: 'Charts',
        children: [
          {
            title: 'Profit',
            link: '/:brand/profit-after-controllable',
          },
          {
            title: 'F&P',
            link: '/:brand/food-and-paper',
          },
          {
            title: 'Comp Performance',
            link: '/:brand/comp-sales',
          },
          {
            title: 'Comp Sales',
            link: '/:brand/comp-store-sales-trends',
          },
        ],
      },
      {
        title: 'Weekly Sales',
        link: '/:brand/accounting_sales_report',
      },
    ],
  },
  {
    title: 'Administration',
    children: [
      {
        title: 'Groups',
        link: '/:brand/groups',
      },
      {
        title: 'Locations',
        link: '/:brand/locations',
      },
    ],
  },
]

export default [
  bibibopOriginalPages,
  bibibopSystemwideOverview,
  bibibopFlash,
  bibibopKpis,
  bibibopHome,
  bibibopHaccps,
  bibibopIntraday,
  bibibopExpenses,
  bibibopPAndL,
  bibibopOpsDashboard,
  bibibopRankings,
  bibibopInventory,
  bibibopDelivery,
  bibibopLocationManagementConfig,
  bibibopGroupManagementConfig,
  bibibopProduct,
  bibibopAccountingSalesReport,
]
